import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import UserCartHook from "../../hook/cart/UserCartHook";

const MobileTabBar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

  const [userData, setUserData] = useState(null);
  const [res] = UserCartHook();
  const notLoginNumberOfCartItems = useSelector((state) => state.cartReducer.notLoginCartNumberOfItems);

  const [showProfileMenu, setShowProfileMenu] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("user") != null) {
      setUserData(JSON.parse(localStorage.getItem("user")));
    }
  }, []);

  const getCartCount = () => {
    if (userData) {
      return res?.numOfCartItems || 0;
    } else {
      return notLoginNumberOfCartItems?.numberOfItems || 0;
    }
  };

  const getCartLink = () => {
    if (settingsRes?.data?.hasNotLoginCart == true) {
      return userData ? "/cart" : "/usercart";
    }
    return "/cart";
  };

  const handleProfileClick = (e) => {
    e.preventDefault();
    if (userData) {
      setShowProfileMenu(!showProfileMenu);
    } else {
      navigate("/login");
    }
  };

  const logOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.removeItem("user");
    localStorage.removeItem("page");
    localStorage.removeItem("token");
    setUserData(null);
    setShowProfileMenu(false);
    navigate("/login");
  };

  const changeLang = (e, lang) => {
    e.preventDefault();
    e.stopPropagation();
    i18n.changeLanguage(lang);
    setShowProfileMenu(false);
  };

  const navigateTo = (e, path) => {
    e.preventDefault();
    e.stopPropagation();
    setShowProfileMenu(false);
    navigate(path);
  }

  const tabs = [
    { name: t("Main"), icon: "fa-house", path: "/", isProfile: false },
    { name: t("categories"), icon: "fa-layer-group", path: "/allcategory", isProfile: false },
    { name: t("cart"), icon: "fa-cart-shopping", path: getCartLink(), badge: getCartCount(), isProfile: false },
    { name: t("profile"), icon: "fa-user", path: "#", isProfile: true },
  ];

  return (
    <>
      {/* Overlay to close menu when clicking outside */}
      {showProfileMenu && (
        <div 
          onClick={() => setShowProfileMenu(false)}
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1040, backgroundColor: "rgba(0,0,0,0.1)" }}
        />
      )}

      <div className="mobile-tab-bar d-md-none font" style={{ zIndex: 1050 }}>
        {tabs.map((tab, index) => {
          const isActive = tab.isProfile 
            ? (location.pathname.includes("/user/") || location.pathname.includes("/admin/") || location.pathname.includes("/vendor/"))
            : (location.pathname === tab.path || (tab.path !== "/" && location.pathname.startsWith(tab.path)));
          
          if (tab.isProfile) {
            return (
              <div 
                key={index}
                className={`tab-item position-relative ${isActive ? "tab-active" : ""}`} 
                style={{ 
                  color: isActive ? primaryColor : "#a0aec0",
                  backgroundColor: isActive ? `${primaryColor}1A` : "transparent",
                  cursor: "pointer"
                }}
                onClick={handleProfileClick}
              >
                <div className="position-relative d-flex align-items-center">
                  <i className={`fa-solid ${tab.icon} tab-icon`}></i>
                </div>
                <span className="tab-label">{tab.name}</span>

                {/* Animated Expandable Menu */}
                <div className={`floating-menu-container ${showProfileMenu ? 'expanded' : ''}`} style={{ left: i18n.language === 'ar' ? '0' : 'auto', right: i18n.language === 'en' ? '0' : 'auto' }}>
                  
                  <button className="floating-menu-item text-danger" onClick={logOut}>
                    <i className="fa-solid fa-arrow-right-from-bracket"></i>
                    <span>{t("logout")}</span>
                  </button>


                  {userData?.role === "user" ? (
                    <>
                      <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/user/addresses')}>
                        <i className="fa-solid fa-map-location-dot text-muted"></i>
                        <span>{t("personal addresses")}</span>
                      </button>
                      <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/user/favoriteproducts')}>
                        <i className="fa-regular fa-heart text-muted"></i>
                        <span>{t("Prefered products")}</span>
                      </button>
                      <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/user/allorders')}>
                        <i className="fa-solid fa-box-open text-muted"></i>
                        <span>{t("orders")}</span>
                      </button>
                      <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/user/profile')}>
                        <i className="fa-regular fa-id-badge text-muted"></i>
                        <span>{t("profile")}</span>
                      </button>
                    </>
                  ) : userData?.role === "admin" ? (
                    <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/admin/products')}>
                      <i className="fa-solid fa-gauge text-muted"></i>
                      <span>{t("control panel")}</span>
                    </button>
                  ) : (
                    <button className="floating-menu-item" onClick={(e) => navigateTo(e, '/vendor/profile')}>
                      <i className="fa-regular fa-id-badge text-muted"></i>
                      <span>{t("profile")}</span>
                    </button>
                  )}
                </div>
              </div>
            );
          }

          return (
            <Link 
              to={tab.path} 
              key={index}
              className={`tab-item ${isActive ? "tab-active" : ""}`} 
              style={{ 
                color: isActive ? primaryColor : "#a0aec0",
                backgroundColor: isActive ? `${primaryColor}1A` : "transparent"
              }}
            >
              <div className="position-relative d-flex align-items-center">
                <i className={`fa-solid ${tab.icon} tab-icon`}></i>
                {tab.badge > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem', padding: '0.2rem 0.4rem', marginTop: '-4px' }}>
                    {tab.badge}
                  </span>
                )}
              </div>
              <span className="tab-label">{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default MobileTabBar;
